import { render, staticRenderFns } from "./font.vue?vue&type=template&id=82cd12cc&scoped=true&"
var script = {}
import style0 from "./font.vue?vue&type=style&index=0&id=82cd12cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cd12cc",
  null
  
)

export default component.exports